import { useFormContext } from 'react-hook-form'
import { ICONE } from 'icons'
import { BaseSelectModal } from 'inputs'
import { BaseGridLayout } from 'layout'
import { useUser } from '../../userManagement/userProvider/UserProvider'
import HeaderGruppo from './HeaderGruppo'
import { creaLabelGruppo } from './utilPermessiEntita'

export default function SelectSceltaGruppi(props) {
  const { getGruppiUtente } = useUser()

  const {
    gruppiScelti,
    options = getGruppiUtente(),
    contenutoPrimaDelBottone,
    propsGrid,
    ...restProps
  } = props

  const risultatiUseForm = useFormContext()

  let gruppiSceltiDefinitivi = (
    gruppiScelti
    || risultatiUseForm?.watch(restProps.name)
    || []
  )

  return (
    <BaseGridLayout vertical spacing={1} {...propsGrid}>
      <BaseGridLayout alignCenter>
        {contenutoPrimaDelBottone}

        <BaseSelectModal
          sceltaMultipla
          options={options}
          getOptionKey={({ codice }) => codice}
          renderOption={gruppo =>
            <HeaderGruppo gruppo={gruppo} senzaPadding={false} />
          }
          getOptionLabel={creaLabelGruppo}
          getOptionSearchString={
            ({ nome }) => [nome].join(' ')
          }

          label='Gruppi'
          chipIcon={<ICONE.GRUPPO />}
          labelRicerca='nome'
          {...restProps}
        />
      </BaseGridLayout>

      <BaseGridLayout alignCenter spacing={4}>
        {gruppiSceltiDefinitivi.map(gruppo =>
          <HeaderGruppo
            gruppo={gruppo}
            ignoraLivelloProfondita
            key={gruppo.codice}
            iconaNonColorata
          />
        )}
      </BaseGridLayout>
    </BaseGridLayout>
  )
}